





















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilteredUserPayload } from '@/store/modules/users/types/users.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';

@Component({
  components: {},
})
export default class ProjectFilter extends Vue {
  @Prop(Object) public filterParams!: any;
  public projectStatusOptions = {
    all: '',
    active: 'active',
    draft: 'draft',
    archived: 'archived',
  };
  public administratorStatusOptions = {
    all: '',
    active: 'active',
    expired: 'expired',
  };

  @Watch('filterParams', { deep: true })
  public onChange() {
    this.$emit('input', this.filterParams);
  }
}
